import React from 'react';
import {Checkbox, FormControlLabel, Stack, Typography} from '@mui/material';
import PropTypes from 'prop-types';

/* A school picks people one by one, then decides for each whether the form goes to them or
   stays away from them. Leaving a person out beats every group they belong to. */
const IndividualRecipientList = ({label, filters, disabled = false, onChange}) => {
    const chosen = (filters ?? []).filter(filter => !filter.isDeleted);

    if (chosen.length === 0) {
        return null;
    }

    const nameOf = filter => filter.label ||
        `${filter.preferredForename ?? ''} ${filter.preferredSurname ?? ''}`.trim() ||
        filter.displayName ||
        'this person';

    const toggle = (id, excluded) =>
        onChange((filters ?? []).map(filter => filter.id === id ? {...filter, excluded} : filter));

    return (
        <Stack sx={{mt: 1, mb: 1}}>
            <Typography variant="body2" color="text.secondary">
                {label}
            </Typography>
            {chosen.map(filter => (
                <FormControlLabel
                    key={filter.id}
                    disabled={disabled}
                    control={
                        <Checkbox
                            size="small"
                            checked={Boolean(filter.excluded)}
                            onChange={event => toggle(filter.id, event.target.checked)}
                        />
                    }
                    label={`Leave ${nameOf(filter)} out`}
                />
            ))}
        </Stack>
    );
};

IndividualRecipientList.propTypes = {
    label: PropTypes.string.isRequired,
    filters: PropTypes.array,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired
};

export default IndividualRecipientList;
